
import { AppBar, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
// import MuiDialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import React from "react";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// const DialogTitle = (props => {
//     const { children, actionsTitle } = props;
//     return (
//         <MuiDialogTitle disableTypography >
//             <AppBar position="relative" color="primary" elevation={0}>
//                 <Toolbar>
//                     <div style={{ display: 'flex', flexDirection: 'column' }}>
//                         {children}
//                     </div>
//                     {actionsTitle &&
//                         <div >
//                             {actionsTitle}
//                         </div>
//                     }
//                 </Toolbar>
//             </AppBar>
//         </MuiDialogTitle>
//     );
// });

const BaseDialog = ({ ...props }) => {
    const { open, title, showClose = false, actionsTitle, onExited, fullScreen, maxWidth = 'md', keepMounted, fullWidth } = props;
    const theme = useTheme();
    const fullScreenMedia = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return;
        if (props.onClose) {
            props.onClose();
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onTransitionExited={onExited}
            onClose={handleClose}
            fullScreen={fullScreenMedia || fullScreen}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            // disableEscapeKeyDown
            // disableBackdropClick
            keepMounted={keepMounted}>
            <DialogTitle sx={{ m: 0, p: 0 }}>
                <AppBar sx={{ position: 'relative' }} color="primary" elevation={0}>
                    <Toolbar>
                        <Typography sx={{ flex: 1 }} variant="h6" component="span">{title}</Typography>
                        {actionsTitle &&
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {actionsTitle}
                            </Box>
                        }
                        {showClose &&
                            <IconButton
                                sx={{ ml: 2 }}
                                edge="end"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        }
                    </Toolbar>
                </AppBar>
            </DialogTitle>
            <DialogContent dividers sx={{ backgroundColor: '#F0F6EB' }}>
                {props.children}
            </DialogContent>
            {props.actions &&
                <DialogActions>
                    <Box sx={{ gap: 2, display: 'flex', }}>
                        {props.actions}
                    </Box>
                </DialogActions>
            }
        </Dialog>
    );
}

export default BaseDialog;